export function getFinalSurveyRoute(template, surveyType) {
  if (template && template.finalSurveyFromAPI) {
    return "finalsurveyapi";
  }
  if (surveyType === 10) return "finalsurvey10";
  if (surveyType === 11) return "finalsurvey11";
  return "finalsurvey";
}
